export default {
  isEditMode: state => state.isEditMode,
  getPageProperties: state => state.pageProperties,
  getPages: state => Object.keys(state.pageProperties),
  selectedPagebuilderItem: state => state.pageBuilder.selectedField,
  customerToken: state => state.customerToken,
  receiptToken: state => state.receiptToken,
  getSerial: state => state.serial,
  getModelNumber: state => state.modelNumber,
  campaignId: state => state.campaignId,
  hostCountry: state => state.hostCountry,
  uploadPercentage: state => state.uploadPercentage,
  signedUp: state => state.signedUp,
  languages: state => state.languages,
  userType: state => state.userType,
  getReferenceNumber: state => {
    console.log(state)
    return state.referenceNumber
  },


  currentPage: state => () => {
    if (state.pageStatus) {
      return state.pageStatus.current.pageName
    }
    return undefined
  },
  selectedProduct: state => (componentId) => {
    if (state.componentStatus[componentId]) {
      return state.componentStatus[componentId]
    }
    return "Not Set"
  },
  hasUnresolvedDependencies (state) {
    return fields => {
      if (!fields || !fields.length) {
        return false
      }
      const resolvedFields = fields
        .map(field => state.componentStatus[field])
        .filter(field => field)

      return resolvedFields.length !== fields.length
    };
  },
  surveyResult: state => state.surveyResult
}